'use client'

interface Props {
  images: {
    url: string
    thumb: string
    caption?: string
  }[]
  loading: boolean
  onSelect: (image: any) => void
}

export function ImageGrid({ images, loading, onSelect }: Props) {
  if (loading) {
    return (
      <div className="text-sm text-muted-foreground">
        Cargando imágenes…
      </div>
    )
  }

  if (!images.length) {
    return (
      <div className="text-sm text-muted-foreground">
        No hay imágenes todavía
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {images.map(img => (
        <button
          key={img.url}
          onClick={() => onSelect(img)}
          className="group relative rounded-lg overflow-hidden border hover:ring-2 hover:ring-primary aspect-square"
        >
          <img
            src={img.thumb}
            alt=""
            className="w-full h-full object-cover"
          />
        </button>
      ))}
    </div>
  )
}
